import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '../layouts/MainLayout.vue'
import NotificationsView from '@/views/NotificationsView.vue'

// Lazy-loaded view components
const DashboardView = () => import('../views/DashboardView.vue')
const TestCasesView = () => import('../views/TestCasesView.vue')
const TestExecutionView = () => import('../views/TestExecutionView.vue')
const AutomationView = () => import('../views/AutomationView.vue')
const ReportsView = () => import('../views/ReportsView.vue')
const LoginView = () => import('../views/LoginView.vue')
const RegisterView = () => import('../views/RegisterView.vue')
const ProfileView = () => import('../views/ProfileView.vue')
const SettingsView = () => import('../views/SettingsView.vue')

const routes = [
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: DashboardView
      },
      {
        path: 'test-cases',
        name: 'TestCases',
        component: TestCasesView
      },
      {
        path: 'test-cases/new',
        name: 'NewTestCase',
        component: TestCasesView
      },
      {
        path: 'test-cases/:id([0-9a-fA-F-]+)/:slug',
        name: 'TestCaseView',
        component: TestCasesView,
        props: true
      },
      {
        path: 'test-execution',
        name: 'TestExecutionList',
        component: TestExecutionView
      },
      {
        path: 'test-execution/:id(\\d+)/:slug',
        name: 'TestExecutionRun',
        component: TestExecutionView,
        props: true
      },
      {
        path: 'automation',
        name: 'Automation',
        component: AutomationView
      },
      {
        path: 'reports',
        name: 'Reports',
        component: ReportsView
      },
      {
        path: 'profile',
        name: 'Profile',
        component: ProfileView
      },
      {
        path: 'settings',
        name: 'Settings',
        component: SettingsView
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: NotificationsView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView,
    meta: { guest: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: () => {
      const user = localStorage.getItem('user')
      return user ? '/dashboard' : '/login'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Navigation guard for auth
router.beforeEach((to, from, next) => {
  const user = localStorage.getItem('user')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isGuestRoute = to.matched.some(record => record.meta.guest)

  // If it's a guest route (login/register) and user is logged in, redirect to dashboard
  if (isGuestRoute && user) {
    return next('/dashboard')
  }

  // If route requires auth and no user is logged in, redirect to login
  if (requiresAuth && !user) {
    return next('/login')
  }

  // If we have a user, try to parse it to validate the structure
  if (user) {
    try {
      const userData = JSON.parse(user)
      if (!userData.token || !userData.email) {
        // Invalid user data structure, clear it and redirect to login
        localStorage.removeItem('user')
        return next('/login')
      }
    } catch (e) {
      // Invalid JSON, clear it and redirect to login
      localStorage.removeItem('user')
      return next('/login')
    }
  }

  next()
})

export default router
